import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IonInput, ModalController, Platform } from "@ionic/angular";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
//Services
import { StorageService } from "src/app/services/storage/storage.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { RouterService } from "src/app/services/router/router.service";
import { LoaderService } from "src/app/services/loader/loader.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { SmsReceiveService } from "src/app/services/smsReceive/sms-receive.service";
import { TagsService } from "src/app/services/tags/tags.service";
//import { JwtHelperService } from '@auth0/angular-jwt';
import { EmblueService } from 'src/app/services/emblue/emblue.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';
import { first } from 'rxjs/operators';
import { UtilsService } from "src/app/services/utils/utils.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";

@Component({
  selector: "app-otp",
  templateUrl: "./otp.page.html",
  styleUrls: ["./otp.page.scss"],
})
export class OtpPage implements OnInit {
  @Input () isLoginConfirmation  = false;
  confirmationResult: any;
  otpForm: FormGroup;
  LOADER_ID = "otp";
  messageError: Promise<string>;
  phoneLogin = false;
  flatActivateResendOtp: boolean;
  titleOtp: string[];
  animationDuration = 60000;
  renderOnClick = false;
  public phoneToRegister;
  token: any;
  tokenPush: any;
  multiples_accounts: boolean = false;
  error = "";

  constructor(
    private route: ActivatedRoute,
    private storageService: StorageService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private routerService: RouterService,
    private loaderService: LoaderService,
    private exceptionService: ExceptionsService,
    private alertService: AlertService,
    public languageService: LanguagesService,
    private smsReceiveService: SmsReceiveService,
    private platform: Platform,
    private tagsService: TagsService,
    private emblueService: EmblueService,
    private fcmService: FcmService,
    private utilsService: UtilsService,
    public remoteConfig: RemoteConfigService,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    console.log(this.isLoginConfirmation);
    
    this.tagsService.setEventTag('otp', 'register_otp_phone_screen_viewed', true, false, 'phone')
    let idElementRecaptcha = this.isLoginConfirmation ? "phone-sign-in-recaptcha-confirmation" : "phone-sign-in-recaptcha"
    
    this.authService.prepareRecaptcha(idElementRecaptcha);
    this.otpForm = this.formBuilder.group({
      code1: ["", Validators.required],
      code2: ["", Validators.required],
      code3: ["", Validators.required],
      code4: ["", Validators.required],
      code5: ["", Validators.required],
      code6: ["", Validators.required],
    });
    this.getPhoneFromStorage();
    this.configOtp();
  }

  configOtp() {
    this.titleOtp = this.getTextIUOtp.label_loading;
    this.renderOnClick = false;
    setTimeout(() => {
      this.titleOtp = this.getTextIUOtp.label_resend;
      this.animationDuration = 0;
      this.flatActivateResendOtp = true;
      this.renderOnClick = true;
    }, this.animationDuration);
  }
  async getPhoneFromStorage() {
    if (this.flatActivateResendOtp === false) return;

    this.flatActivateResendOtp = false;
    this.animationDuration = 60000;
    this.configOtp();
    this.loaderService.presentLoading(this.LOADER_ID);
    const phoneToRegister = await this.storageService.get("phoneRecover");
    this.phoneToRegister = phoneToRegister;
    if (phoneToRegister) {
      try {
        await this.signinWithPhoneNumber(phoneToRegister);
        this.loadSmsRecieve();
        this.loaderService.cancelLoader(this.LOADER_ID);
      } catch (err) {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.exceptionService.renderError(err);
        this.routerService.redirectBack();
      }
    }
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  loadSmsRecieve() {
    if (this.platform.is("android") || this.platform.is("ios")) {
      this.smsReceiveService.OTP$.subscribe((otp: string) => {
        this.loadingOtpAutomatically(otp);
      });
    }
  }
  private loadingOtpAutomatically(otp: string) {
    let timer = 140;
    for (let i = 1; i <= 6; i++) {
      let code = `code${i}`;
      setTimeout(() => {
        this.otpForm.controls[code].setValue(otp.charAt(i - 1));
      }, timer);
      timer = timer + 140;
    }
    setTimeout(() => {
      this.VerfiyAllNumberCodes();
    }, timer);
  }
  async signinWithPhoneNumber(phone) {
    this.confirmationResult = await this.authService.makeLoginWithPhone(phone);
  }

  async VerfiyAllNumberCodes() {
    if (this.otpForm.valid) {
      const { code1, code2, code3, code4, code5, code6 } = this.otpForm.value;
      const finalCode = code1 + code2 + code3 + code4 + code5 + code6;
      try {
        await this.confirmationResult.confirm(finalCode);
        await this.loginUserWithPhone();
      } catch (err) {
        console.log(err);
        this.exceptionService.renderError(err);

        switch (err.code) {
          case 'auth/captcha-check-failed':
            this.error = 'Captcha invalido';
            break;
          case 'auth/invalid-phone-number':
            this.error = 'Número teléfonico invalido';
            break;
          case 'auth/missing-phone-number':
            this.error = 'Número no encontrado';
            break;
          case 'auth/quota-exceeded':
            this.error = 'Se excedió la cuota. Comunícate con tu asesor';
            break;
          case 'auth/user-disabled':
            this.error = 'Usuario deshabilitado';
            break;
          case 'auth/operation-not-allowed':
            this.error = 'Operación no permitida';
            break;
          default:
            break;

        }
      }
    }
  }


  async loginUserWithPhone() {
    this.loaderService.presentLoading(this.LOADER_ID);
    try {
      const tokenFB = await this.authService.callFbToken();
      var tokenGnx = await this.authService.getAccessFromUsers(tokenFB);
      await this.storageService.set('token-otp', tokenGnx);
      this.routerService.redirect('new-password');
      if (typeof this.utilsService.parseJwt(tokenFB).gluky === 'undefined') {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.alertService.presentAlert('Este número de telefono no se encuentra registrado, registrate acontinuación');
        console.log('loginUserWithPhone tokenGnx undefined', tokenGnx);
        return this.routerService.redirect('register');
      }

      this.authService.setCurrentTokenGnx(tokenGnx);
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.tagsService.setEventTag('otp', 'login_page_success', true, false, 'phone');
      if (this.isLoginConfirmation) {
       this.modalController.dismiss({isLoginConfirmation: true});
      } else {
        await this.saveTokenGNX(tokenGnx);
        console.log('loginUserWithPhone tokenGnx else isLoginConfirmation', tokenGnx);
       // this.routerService.redirect("app/home");
      }
     // return this.routerService.redirect("app/home");
    } catch (err) {
      this.tagsService.setEventTag('otp', 'login_page_error', true, false, 'phone')
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.exceptionService.renderError(err);
    }
  }
  back(){
    console.log("back");
    if (this.isLoginConfirmation) {
      this.modalController.dismiss({isLoginConfirmation: false});
    } else {
      this.routerService.redirect("/login");
    }
    
  };
  gotoNextField(nextElement, code: IonInput) {
    if (!code.value) return;
    let inputCode = Number(code.value);
    for (let i = 0; i <= 9; i++) {
      if (i === inputCode) {
        console.log(nextElement);
        
        if (nextElement) {
          nextElement.setFocus();
          break;
        }
      }
    }
  }
  async saveTokenGNX(tokenGNX: any) {
    this.loaderService.cancelLoader(this.LOADER_ID);
    if (tokenGNX.match) {
      await this.storageService.set("gnx-token", tokenGNX);
    }
    try {
      await this.emblue();
    } catch (error) {
      console.log("error emblu set", error);
    }
  }

  get getTextIUOtp() {
    return this.languageService.textsIU.page_otp;
  }

  async emblue() {
    //console.log(" this.phoneToRegister: " ,  this.phoneToRegister );
    //let email = 'idcelular_' + this.phoneToRegister + '@nomail.com';
    await this.fcmService.getUserInfoUser().pipe(first()).subscribe((user: any) => {
      if (user) {
        this.emblueService.getToken().then(async (token: any) => {
          let user_email = (user.email) ? user.email : 'mobile_' + user.phone.trim() + '@nomail.com';
          this.token = token;
          this.tokenPush = this.fcmService.tokenFcm;
          var phone_user = this.emblueService.validationPhone(user.phone);
          let editCustomFields = "telefono_1:|:" + phone_user + ":|:1|||nombre:|:" + user.name + ":|:1|||apellido:|:" + user.lastnames + ":|:1|||id_contacto:|:" + user.gnxCredential1 + ":|:1|||email_secundario:|:" + user_email + ":|:1|||push_fb:|:" + this.tokenPush + ":|:1";
          //console.log("login editCustomFields", editCustomFields);
          //console.log("tokens",   this.token, " fcm: ", this.tokenPush);
          this.emblueService.setAssociatePushToEmail(user_email, this.token, this.fcmService.tokenFcm).then(data => {
            console.log("setAssociatePushToEmail", data);
            this.emblueService.setNewContact(user_email, editCustomFields, this.token).then(result => {
              console.log("setNewContact", result);
            });
          });
        });
      }
    });
  }
}
